import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/video/NYONI.jpg';
import _imports_1 from '../../assets/video/NYONI.mp4';
const _hoisted_1 = {
  class: "relative"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "bgvid",
  src: _imports_0,
  alt: ""
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("video", {
  class: "bgvid",
  id: "bgvid",
  src: _imports_1,
  poster: _imports_0,
  playsinline: "",
  autoplay: "",
  muted: "",
  loop: ""
}, null, -1);
const _hoisted_4 = {
  class: "header-title"
};
const _hoisted_5 = {
  class: "preTitle"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "header-content"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("header", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("home.header.title1")), 1), _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("home.header.title2")), 1)]), _hoisted_7]);
}